/**
 * @generated SignedSource<<c55d9bf20697d2e5863d82ceb2a576af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SlideCaption_slide",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    }
  ],
  "type": "Slide",
  "abstractKey": null
};

node.hash = "8a1794e4e670e645cab89f618819a220";

module.exports = node;
